module.exports = __webpack_public_path__ + "static/branding-6b30a4dddb6f06833f9d014e9cc0ef8b.svg";